export default __webpack_public_path__ + "static/media/arrangement-whorled.c86662c2.PNG";